/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'travelpath': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M0 192L320 64v768L0 960zM384 32l320 192v736L384 800zm384 192l256-192v768L768 992z" _fill="#555"/>'
  }
})
